import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from "../../../../../shared/services/common.service";
import { DatePipe } from '@angular/common';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-proposal',
  templateUrl: './proposal.component.html',
  styleUrl: './proposal.component.css',
  providers: [DatePipe],
})
export class ProposalComponent implements OnInit {

  proposalUserId: string | null = null;
  record: string | null = null;
  Implementing_Agency_DetailsForm: FormGroup<any>;
  Implementation_Details: FormGroup;
  Geography_and_Timeline: FormGroup;
  Training_Delivery: FormGroup;
  Intervention_MilestonesForm: FormGroup;
  DetailedFinancials: FormGroup;
  ImplementingAgencyDetailsFormSubmitted = false;
  Implementation_DetailsSubmitted = false;
  Geography_and_TimelineSubmitted = false;
  Training_DeliverySubmitted = false;
  Intervention_MilestonesSubmitted = false;
  DetailedFinancialsSubmitted = false;
  currentStep: number = 1;
  Intervention_help: any[] = [];
  budgetHead_help: any[] = [];
  Component_help: any[] = [];
  district_help: any[] = [];
  Implementation_Details_submitList: any[] = [];
  Implementation_Details_Agency_submitList: any[] = [];
  Geography_and_Timeline_submitList: any[] = [];
  Intervention_Milestones_submitList: any[] = [];
  DetailedFinancials_submitList: any[] = [];
  proposalGeographyObj: any
  interventionMilestonesobj: any
  proposalImplementationDetails: any
  trainingDelivery: any
  DetailedFinancials_Details: any
  uploadProposal: any

  maxBudget: any;
  maxMSME: any;
  maxCost: any;
  minMSME: any;
  maxTargetMSME: any;
  remainingTargetMSME: any;
  BudgetPerBeneficiary: any;
  route: any;
  userId: string = '';
  isDisabled: boolean = true;
  IAProileDetails_help: any[] = [];
  BriefBackgroundIA: string = '';
  SummaryScaleIA: string = '';
  isDuplicateMilstone: boolean = false;
  hiddenProposalId = 0;
  fileUrl: string | null = null;
  fileName: string = ''; // Store file name separately
  uploadError: string | null = null;
  certificateFile: File | null = null;
  iauserid: string | null = null;
  isHiddenUpdate: boolean = false;
  isHiddenSubmit: boolean = false;
  isBtnEdit: boolean = false;
  isBtnDelete: boolean = false;
  isBtnNext: boolean = true;
  isBtnNextGeo: boolean = true;
  uploadProposalPathData: string = '';
  uploadProposalDocumentData: string = '';
  TotalTargetMSMECount: any;
  isBtnAdd: boolean = false;
  isBtnAddGeo: boolean = false;
  isBtnAddMile: boolean = false;
  isTotalTargetMSMECount: boolean = false;
  selectedText: string | null = null;
  isTarget: boolean = true;
  isTargetGeo: boolean = true;
  isSubmitted = false;
  isUploadProposalCertificate: boolean = false;
  beneficiariesList:any = [];

  get f() { return this.Implementing_Agency_DetailsForm.controls; }
  get k() { return this.Implementation_Details.controls; }
  get g() { return this.Geography_and_Timeline.controls; }
  get t() { return this.Training_Delivery.controls; }
  get m() { return this.Intervention_MilestonesForm.controls; }

  get b() { return this.DetailedFinancials.controls; }
  startDateTime: Date | null = null;
  minDate = new Date();
  proposalStartDate = new Date();
  proposalSelectedDate = new Date();
  
  constructor(public dialog: MatDialog, private fb: FormBuilder,
    private apiService: ApiService, private toastrService: ToastrService, private router: Router, private routes: ActivatedRoute,
    private commonService: CommonService, private datePipe: DatePipe) {


    this.userId = sessionStorage.getItem("iauserid") || '';
    this.getIAProfile_help(this.userId);
    this.getintervention_help(this.userId);
    localStorage.clear();
    this.Getdistrict();
    this.Implementing_Agency_DetailsForm = this.fb.group({
      interventionId: ['', [Validators.required]],
      //componentId: ['', [Validators.required]],
      componentId: [{ value: '', disabled: true }, [Validators.required]],
      //approved_Budget: [{ value: '', disabled: true }, [Validators.required]],
      //targetMSME: ['', Validators.required],
      targetMSME: ['', [Validators.required, Validators.minLength(1)]],
      rate_per_Beneficiary_MSME: [{ value: '', disabled: true }, [Validators.required]],
      noOfEvent: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]],
      bbImplementAgency: [{ value: '', disabled: true }, [Validators.required, Validators.min(1)]],
      ssProjectImplementAgency: [{ value: '', disabled: true }, [Validators.required, Validators.min(1)]],
      pragramNameConduct: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]],
      measurableOutcomes: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]],
      uploadProposalPathData: [''],
      uploadProposalDocumentData: ['']
    });
    this.Implementation_Details = this.fb.group({
      id: [''],
      engagementPartnerName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(150),
      Validators.pattern(this.commonService.nameOfOrganisation)]],
      districtId: ['', [Validators.required, Validators.min(1)]],
      //engagementPartnerName: [''],
      //districtId: [''],
      noOfWorkshop: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(3)]],
      targets: ['', [Validators.required, Validators.minLength(1)]]
    });
    this.Geography_and_Timeline = this.fb.group({
      id: [''],
      proposedDateTraining: ['', Validators.required],
      proposedDistrict: ['', Validators.required],      
      proposedVenue: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]],
      proposedNoOfWorkshop: ['', [Validators.required, Validators.min(1), Validators.maxLength(3)]],
      totalTarget: ['', [Validators.required, Validators.min(1)]],
    });
    this.Training_Delivery = this.fb.group({
      /*detailsCDCC: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(2000)]],*/
      detailsCDCC: ['', [Validators.required, Validators.minLength(3)]],
      durationWorkshop: ['', [Validators.required, Validators.min(1), Validators.maxLength(2)]],
      qualificationTrainers: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(150),
      Validators.pattern(this.commonService.nameOfOrganisation)]],
      beneficiariesId: ['', [Validators.required, Validators.min(1)]],
      proposedCertificationWorkshops: ['1', [Validators.required, Validators.min(1), Validators.maxLength(3)]],
    });
    this.Intervention_MilestonesForm = this.fb.group({
      id: [''],
      milestone: [{ value: '' }, [Validators.required, Validators.minLength(1), Validators.maxLength(150)]],
      projectStartDate: ['', Validators.required],
      durationInMonth: ['', [Validators.required, Validators.min(1), Validators.maxLength(2)]],
      estimatedProjectClosure: ['', [Validators.required]],
      uploadProposalCertificate: ['', [Validators.required]]
    });
    this.DetailedFinancials = this.fb.group({
      id: [''],
      //budgetHeadId: ['', [Validators.required]],
      budgetHeadId: [{ value: '', disabled: true }, [Validators.required]],
      cost: [{ value: '', disabled: true }, [Validators.required, Validators.min(1)]],
      //cost: ['', [Validators.required, Validators.min(1)]],
    });
    //this.verifyproposal = this.fb.group({
    //  uploadProposalCertificate: ['', [Validators.required]]
    //});

    this.Implementing_Agency_DetailsForm.controls['interventionId'].setValue(null);
    this.Implementing_Agency_DetailsForm.controls['componentId'].setValue(null);

    this.Implementation_Details.controls['districtId'].setValue(null);
    this.Geography_and_Timeline.controls['proposedDistrict'].setValue(null);

    this.Training_Delivery.controls['beneficiariesId'].setValue(null);
  }

  ngOnInit(): void {
    this.routes.params.subscribe(params => {
      this.proposalUserId = params['id'];
      if (this.proposalUserId) {
        this.getProposalDetails(this.proposalUserId);
      }      
    });
    this.maxCost = 999999999;
    this.minDate.setDate(this.minDate.getDate() + 1); // Set to tomorrow
    sessionStorage.setItem('storeFileName', '');

    this.beneficiariesList = [
      { value: '1', text: 'MSME' },
      { value: '2', text: 'Entrepreneur' },
      { value: '3', text: 'MSME Employee' },
      { value: '4', text: 'MEME Aspirant' }
    ];
    
  }

  getProposalDetails(proposalUserId: string) {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETPROPOSALSUBMISSIONDETAILS, { ProposalUserId: proposalUserId }).subscribe(
      (response) => {
        if (response.status) {
          //console.log(response.data.item1);

          //this.Implementing_Agency_DetailsForm.controls['interventionId'].setValue(null);
          //this.Implementing_Agency_DetailsForm.controls['componentId'].setValue(null);
          
          var interId = response.data?.item1.interventionId;
          this.GetComponent(interId, 'edit1');
          this.isDisabled = false;
          let noOfEvent = response.data?.item1.noOfEvent;
          this.Implementing_Agency_DetailsForm.patchValue({
            interventionId: response.data?.item1.interventionId.toString(),
            targetMSME: response.data?.item1.targetMSME,
            noOfEvent: noOfEvent === 0 ? '' : noOfEvent,
            approved_Budget: response.data?.item1.approved_Budget,
            rate_per_Beneficiary_MSME: response.data?.item1.rate_per_Beneficiary_MSME,
            bbImplementAgency: response.data?.item1.bbImplementAgency,
            ssProjectImplementAgency: response.data?.item1.ssProjectImplementAgency,
            pragramNameConduct: response.data?.item1.pragramNameConduct,
            measurableOutcomes: response.data?.item1.measurableOutcomes,
            proposedCertificationWorkshops: response.data?.item1.proposedCertificationWorkshops,
            msMeId: response.data?.item1.msMeId,
            componentId: response.data?.item1.componentId.toString()
          });
          //this.Implementing_Agency_DetailsForm.controls['interventionId'].setValue(response.data?.item1.interventionId.toString());
          //this.Implementing_Agency_DetailsForm.controls['componentId'].setValue(response.data?.item1.componentId.toString());

          this.Training_Delivery.patchValue(response.data?.item2[0]);
          this.Training_Delivery.patchValue({
            beneficiariesId: response.data?.item1.msMeId,
            proposedCertificationWorkshops: response.data?.item1.proposedCertificationWorkshops
          });
          this.Implementation_Details_submitList = response.data?.item3 || [];
          if (response.data?.item3.length > 0) {            
            this.ChkImplementationDetails();
            if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
              this.isTotalTargetMSMECount = true;
              this.Implementation_Details.disable();
              this.isBtnAdd = true;
              this.isBtnNext = false;
            }
            //this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
            //this.TotalTargetMSMECount = this.Implementation_Details_submitList.reduce((sum, row) => sum + row.targets, 0) + this.Implementation_Details.controls['targets']?.value;
          }
          this.Geography_and_Timeline_submitList = response.data?.item4 || [];
          if (response.data?.item4.length > 0) {
            this.ChkGeographyandTimeline();
            if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
              this.isTotalTargetMSMECount = true;
              this.Geography_and_Timeline.disable();
              this.isBtnAddGeo = true;
              this.isBtnNextGeo = false;
            }           
          }

         
          this.DetailedFinancials_submitList = response.data?.item6 || [];
          this.Intervention_Milestones_submitList = response.data?.item5 || [];

          if (response.data.item5.length > 0) {
            this.Intervention_Milestones_submitList = response.data?.item5 || [];
            //this.isHiddenUpdate = false;
            this.isBtnAddMile = true;
            this.Intervention_MilestonesForm.disable();
            this.isUploadProposalCertificate = true;
            //this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.disable();
          }
          if (response.data.item6.length > 0) {
            this.DetailedFinancials.patchValue({
              //budgetHeadId: response.data?.item6[0].budgetHeadId,
              cost: response.data?.item6[0].cost
            });
          }

          this.uploadProposalPathData= response.data?.item1.uploadProposalPath;
          this.uploadProposalDocumentData = response.data?.item1.uploadProposalDocument;
          
          const mockEvent = interId; // Create a mock event or required parameter
          this.GetApprovedBudgetTargetMSME(mockEvent); // Call the function directly

          
        }
      },
      (error) => {
        console.error('Error fetching proposal details:', error);
      }
    );
  }

  prepareFormData(): FormData {
    const formData = new FormData();
    const userId = sessionStorage.getItem("iauserid");

    // Append values from verifyproposal form
    Object.keys(this.Intervention_MilestonesForm?.value).forEach(key => {
      const value = this.Intervention_MilestonesForm.get(key)?.value;
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    // Create a structured object for complex data
    const obj = {
      interventionId: parseInt(this.Implementing_Agency_DetailsForm.controls['interventionId']?.value),
      componentId: parseInt(this.Implementing_Agency_DetailsForm.controls['componentId']?.value),
      targetMSME: parseInt(this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value),
      noOfEvent: parseInt(this.Implementing_Agency_DetailsForm.controls['noOfEvent']?.value || 0),
      rate_per_Beneficiary_MSME: parseFloat(this.Implementing_Agency_DetailsForm.controls['rate_per_Beneficiary_MSME']?.value),
      bbImplementAgency: this.Implementing_Agency_DetailsForm.controls['bbImplementAgency']?.value,
      ssProjectImplementAgency: this.Implementing_Agency_DetailsForm.controls['ssProjectImplementAgency']?.value,
      pragramNameConduct: this.Implementing_Agency_DetailsForm.controls['pragramNameConduct']?.value,
      measurableOutcomes: this.Implementing_Agency_DetailsForm.controls['measurableOutcomes']?.value,
      proposalGeographyAndTimeline: JSON.parse(this.proposalGeographyObj),
      interventionMilestones: JSON.parse(this.interventionMilestonesobj),
      trainingDelivery: this.trainingDelivery,
      proposalImplementationDetails: JSON.parse(this.proposalImplementationDetails),
      userId: userId,
      msMeId: this.Training_Delivery.controls['beneficiariesId']?.value,
      proposedCertificationWorkshops: this.Training_Delivery.controls['proposedCertificationWorkshops']?.value,
      detailedFinancials: JSON.parse(this.DetailedFinancials_Details),
      proposalUserId: this.proposalUserId ?? ''  // Handles undefined, null, or empty string cases
    };

    // Append JSON data as a string
    formData.append('data', JSON.stringify(obj));

    // Append file if available
    if (this.certificateFile) {
      formData.append('uploadProposalFile', this.certificateFile);
    }
    return formData;
  }




  submitForms() {

    //['id', 'projectStartDate', 'durationInMonth', 'estimatedProjectClosure']
    //  .forEach(field => this.Intervention_MilestonesForm.get(field)?.patchValue(''));

    this.isSubmitted = true;
    //this.proposalGeographyObj = localStorage.getItem('localStorage_Geography_and_Timeline_submitList_submitList');

   
    let rawData = localStorage.getItem('localStorage_Geography_and_Timeline_submitList_submitList');
    let rawMilestoneData = localStorage.getItem('localStorage_Intervention_Milestones_submitList');
    if (rawData) {
      let parsedData = JSON.parse(rawData);
      parsedData.forEach((item: any) => {
        // Convert date from 'dd/MM/yyyy' to 'yyyy-MM-dd'
        let parts = item.proposedDateTraining.split('/');
        if (parts.length === 3) {
          const [day, month, year] = parts;
          item.proposedDateTraining = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      });
      // If needed, assign the modified object back
      this.proposalGeographyObj = JSON.stringify(parsedData);
      // Optionally update localStorage if needed
      // localStorage.setItem('localStorage_Geography_and_Timeline_submitList_submitList', this.proposalGeographyObj);
    }

    //let rawMilestoneData = this.interventionMilestonesobj;

    if (rawMilestoneData) {
      let parsedMilestones = JSON.parse(rawMilestoneData);

      parsedMilestones.forEach((item: any) => {
        // Format projectStartDate
        let startParts = item.projectStartDate.split('/');
        if (startParts.length === 3) {
          const [day, month, year] = startParts;
          item.projectStartDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        // Format estimatedProjectClosure
        let closureParts = item.estimatedProjectClosure.split('/');
        if (closureParts.length === 3) {
          const [day, month, year] = closureParts;
          item.estimatedProjectClosure = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      });

      this.interventionMilestonesobj = JSON.stringify(parsedMilestones);

      // Optionally update localStorage if it's stored there
      // localStorage.setItem('your_storage_key', this.interventionMilestonesobj);
    }





    //this.interventionMilestonesobj = localStorage.getItem('localStorage_Intervention_Milestones_submitList');
    this.proposalImplementationDetails = localStorage.getItem('localStorage_Implementation_Details_submitList');
    this.DetailedFinancials_Details = localStorage.getItem('localStorage_BeneficiariesAndOther_submitList');
    this.trainingDelivery = this.Training_Delivery?.value;
    const formDatas = this.prepareFormData();
    this.isHiddenSubmit = true;
    this.isHiddenUpdate = true;

    this.apiService.postRequest(API_ENDPOINTS.IA.InsertUpdateProposal, formDatas).subscribe(
      res => {
        if (res.status) {
          if (res.message == "limitcrossed") {
            this.toastrService.info("Proposal creation limit exceeded. You cannot create any more proposals at this time.");
          }
          else {
            this.toastrService.success(res.message);
            this.router.navigate(['/iaproposalpage']);
          }
        }
        else {
          this.toastrService.error(res.message);
          this.router.navigate(['/iaproposalpage']);
        }
      }
    );   
  }

  Implementing_Agency_DetailsForm_submit() {
    if (Number(this.maxMSME) === 0) {

      this.isDisabled = true;

      const toastRef = this.toastrService.warning(
        'Maximum MSME count is 0. Submission is not allowed.'
      );

      toastRef.onHidden.subscribe(() => {
        this.isDisabled = false; // ✅ Enable button after toast disappears
      });

      return; // ❌ Stop execution
    }

    this.ImplementingAgencyDetailsFormSubmitted = true;    
    if (this.currentStep === 1) {
      if (this.Implementing_Agency_DetailsForm.valid) {
        this.Implementation_Details_Agency_submitList.push(this.Implementing_Agency_DetailsForm?.value);
        let localStorage_Implementation_Agency_Details_submitList = JSON.stringify(this.Implementation_Details_Agency_submitList)
        localStorage.setItem("localStorage_Implementation_Agency_Details_submitList", localStorage_Implementation_Agency_Details_submitList)
        this.currentStep = 2;
        this.Implementation_DetailsSubmitted = false;
        this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
        this.ChkImplementationDetails();
      }
    }
  }

  ChkImplementationDetails() {
    this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
    this.TotalTargetMSMECount = this.Implementation_Details_submitList.reduce((sum, row) => sum + row.targets, 0) + this.Implementation_Details.controls['targets']?.value;
    if (parseInt(this.TotalTargetMSMECount) > this.maxTargetMSME && this.Implementation_Details_submitList.length > 0) {
      this.isTotalTargetMSMECount = true;
    }
    //else if (parseInt(this.TotalTargetMSMECount) == this.maxTargetMSME) {
    //  this.isBtnNext = true;
    //}
    else {
      this.isTotalTargetMSMECount = false;
    }
  }

  Implementation_Details_submit(status: any, i: any) {
    this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
    this.Implementation_DetailsSubmitted = true;

    this.TotalTargetMSMECount = this.Implementation_Details_submitList.reduce((sum, row) => sum + row.targets, 0) + this.Implementation_Details.controls['targets']?.value;

    if (this.maxTargetMSME >= parseInt(this.TotalTargetMSMECount)) { //|| !this.isBtnEdit|| !this.isBtnNext || !this.isBtnAdd
      if (this.currentStep === 2) {
        if (this.Implementation_Details.valid || this.Implementation_Details_submitList.length > 0) {

          if (this.hiddenProposalId !== null && this.hiddenProposalId !== undefined && this.hiddenProposalId !== 0)
            this.Implementation_Details.get('id')?.setValue(this.hiddenProposalId);
          else
            this.Implementation_Details.get('id')?.setValue(0);


          var obj: any = {
            "id": parseInt(this.Implementation_Details.controls['id']?.value) || 0,
            "engagementPartnerName": this.Implementation_Details.controls['engagementPartnerName']?.value,
            "districtId": parseInt(this.Implementation_Details.controls['districtId']?.value) || 0,
            "noOfWorkshop": this.Implementation_Details.controls['noOfWorkshop']?.value,
            "targets": this.Implementation_Details.controls['targets']?.value,
          }


          if (obj.engagementPartnerName != '' && obj.engagementPartnerName.length > 2 && obj.districtId != ''
            && /^[a-zA-Z ]*$/.test(obj.engagementPartnerName)
            && obj.noOfWorkshop != '' && obj.noOfWorkshop >= 1
            && (obj.targets != '' && obj.targets != 0 && obj.targets != null)) {
            if (obj.targets <= this.maxTargetMSME) {
              //if (obj.noOfWorkshop != '' && obj.targets != '') {
              //const data = this.district_help.filter(x => x.id === obj['districtId']);
              //obj['districtName'] = data[0]['text'];

              const data = this.district_help.find(x => x.id == obj['districtId']);
              obj['districtName'] = data ? data.text : null; // Handle case when no match is found

              //const data = this.district_help.filter(x => x.id === obj['districtId']);
              //obj['districtName'] = data.length > 0 ? data[0]['text'] : 'select'; // Provide a fallback value

              const isDuplicate = this.Implementation_Details_submitList.some(item =>
                //item.id === obj.id &&
                item.engagementPartnerName === obj.engagementPartnerName &&
                item.districtId === obj.districtId &&
                item.noOfWorkshop === obj.noOfWorkshop &&
                item.targets === obj.targets
              );

              if (isDuplicate && status !== 'delete') {
                this.toastrService.error('Duplicate Record Found!', 'Record Found!');
                return;
              }

              if (status == 'submit') {
                this.Implementation_Details_submitList.push(obj);
                let localStorage_Implementation_Details_submitList = JSON.stringify(this.Implementation_Details_submitList)
                localStorage.setItem("localStorage_Implementation_Details_submitList", localStorage_Implementation_Details_submitList)
                this.Implementation_Details.get('engagementPartnerName')?.setValue('');
                this.Implementation_Details.get('districtId')?.setValue('');
                this.Implementation_Details.get('noOfWorkshop')?.setValue('');
                this.Implementation_Details.get('targets')?.setValue('');
                this.hiddenProposalId = 0;
                this.currentStep = 3;
                this.Geography_and_TimelineSubmitted = false;
                this.isBtnEdit = false;
                this.isBtnDelete = false;
                this.ChkGeographyandTimeline();
                this.ChkImplementationDetails();
                if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
                  this.isTotalTargetMSMECount = true;
                  this.Implementation_Details.disable();
                  this.isTarget = false;
                  this.isBtnNext = false;
                  this.isBtnAdd = true;
                }
              }
              else {
                this.currentStep = 2;
                this.Implementation_Details_submitList.push(obj);
                this.Implementation_Details.get('id')?.patchValue('');
                this.Implementation_Details.get('engagementPartnerName')?.patchValue('');
                this.Implementation_Details.get('districtId')?.patchValue('');
                this.Implementation_Details.get('noOfWorkshop')?.patchValue('');
                this.Implementation_Details.get('targets')?.patchValue('');
                this.hiddenProposalId = 0;
                this.Implementation_DetailsSubmitted = false;
                this.isBtnEdit = false;
                this.isBtnDelete = false;
                this.isTarget = true;
                this.Implementation_Details.controls['districtId'].setValue(null);
                if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
                  this.isTotalTargetMSMECount = true;
                  this.Implementation_Details.disable();
                  this.isTarget = false;
                  this.isBtnNext = false;
                  this.isBtnAdd = true;
                }
              }
            }
          }
          else if (status == 'addmore') {
            if (this.Implementation_Details.valid) {
              this.Implementation_Details.controls['districtId'].setValue(null);
              this.ignoreEngagePartnerNameValidator(false, '');
              this.isBtnEdit = false;
              this.isBtnDelete = false;
              this.isBtnNext = false;
              //this.isBtnNext = false;
            }
          }
          //added for edit functionality
          else if (status == 'edit') {
            this.Implementation_Details.get('engagementPartnerName')?.setValue(this.Implementation_Details_submitList[i].engagementPartnerName);
            this.Implementation_Details.get('districtId')?.setValue(this.Implementation_Details_submitList[i].districtId.toString());
            this.Implementation_Details.get('noOfWorkshop')?.setValue(this.Implementation_Details_submitList[i].noOfWorkshop);
            this.Implementation_Details.get('targets')?.setValue(this.Implementation_Details_submitList[i].targets);
            this.hiddenProposalId = this.Implementation_Details_submitList[i].id
            this.Implementation_DetailsSubmitted = false;
            this.Implementation_Details_submitList.splice(i, 1);


            this.isBtnEdit = true;
            this.isBtnDelete = true;
            this.isBtnNext = true;
            this.isBtnAdd = false;
            this.isTarget = true;
            this.isTotalTargetMSMECount = false;
            this.Implementation_Details.enable();

          }
          else if (status == 'delete') {
            this.openConfirmationDialog('ImpDetails', i);            
          }
          else if (status == 'submit') {
            let localStorage_Implementation_Details_submitList = JSON.stringify(this.Implementation_Details_submitList)
            localStorage.setItem("localStorage_Implementation_Details_submitList", localStorage_Implementation_Details_submitList)
            this.currentStep = 3;
            this.Geography_and_TimelineSubmitted = false;
            this.isBtnEdit = false;
            this.isBtnDelete = false;
            this.ChkGeographyandTimeline();
          }
        }       
        else {
          if (status == 'delete') {
            this.openConfirmationDialog('ImpDetails', i);           
          }
        }
      }
    }
    else if (status == 'edit') {
      this.Implementation_Details.get('engagementPartnerName')?.setValue(this.Implementation_Details_submitList[i].engagementPartnerName);
      this.Implementation_Details.get('districtId')?.setValue(this.Implementation_Details_submitList[i].districtId.toString());
      this.Implementation_Details.get('noOfWorkshop')?.setValue(this.Implementation_Details_submitList[i].noOfWorkshop);
      this.Implementation_Details.get('targets')?.setValue(this.Implementation_Details_submitList[i].targets);
      this.hiddenProposalId = this.Implementation_Details_submitList[i].id
      this.Implementation_DetailsSubmitted = false;
      this.Implementation_Details_submitList.splice(i, 1);
      this.isBtnEdit = true;
      this.isBtnDelete = true;
      this.isBtnNext = true;
      this.isBtnAdd = false;
      this.isTarget = true;
      this.isTotalTargetMSMECount = false;
      this.Implementation_Details.enable();

    }
    else if (status == 'delete') {
      this.openConfirmationDialog('ImpDetails', i);       
      //this.Implementation_DetailsSubmitted = false;
      //this.Implementation_Details_submitList.splice(i, 1);
    }
    else if (this.Implementation_Details.controls['targets']?.value > this.maxTargetMSME) {
      this.isBtnAdd = true;
      this.isBtnEdit = true;
      this.isBtnDelete = true;
      this.isTotalTargetMSMECount = false;
    }
    else {
      if (this.Implementation_Details.valid) {
        this.isBtnAdd = true;
        this.isBtnEdit = true;
        this.isBtnDelete = true;
        this.isTotalTargetMSMECount = true;
      }
    }
  }





  Geography_and_Timeline_submit(status: any, i: any) {
    this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
    this.Geography_and_TimelineSubmitted = true;
    this.TotalTargetMSMECount = this.Geography_and_Timeline_submitList.reduce((sum, row) => sum + row.totalTarget, 0) + this.Geography_and_Timeline.controls['totalTarget']?.value;

    //this.checkFormErrors();

    if (this.maxTargetMSME >= this.TotalTargetMSMECount) { //|| !this.isBtnEdit || !this.isBtnNext || !this.isBtnAdd
      if (this.currentStep === 3) {
        if (this.Geography_and_Timeline.valid || this.Geography_and_Timeline_submitList.length > 0) {

          if (this.hiddenProposalId !== null && this.hiddenProposalId !== undefined && this.hiddenProposalId !== 0)
            this.Geography_and_Timeline.get('id')?.setValue(this.hiddenProposalId);
          else
            this.Geography_and_Timeline.get('id')?.setValue(0);

          //const date = new Date();

          //if (this.Geography_and_Timeline?.value.proposedDateTraining != '') {
          //  var proposedDateTraining = this.Geography_and_Timeline?.value.proposedDateTraining;
          //  proposedDateTraining = this.datePipe.transform(proposedDateTraining, 'dd/MM/yyyy');
          //  this.Geography_and_Timeline.get('proposedDateTraining')?.setValue(proposedDateTraining);
          //}

          var obj: any = {
            "id": parseInt(this.Geography_and_Timeline.controls['id']?.value) || 0,
            //"proposedDateTraining": proposedDateTraining,
            "proposedDateTraining": this.datePipe.transform(this.Geography_and_Timeline?.value.proposedDateTraining, 'dd/MM/yyyy'),
            "proposedDistrict": parseInt(this.Geography_and_Timeline.controls['proposedDistrict']?.value),
            "proposedVenue": this.Geography_and_Timeline.controls['proposedVenue']?.value,
            "proposedNoOfWorkshop": this.Geography_and_Timeline.controls['proposedNoOfWorkshop']?.value,
            "totalTarget": this.Geography_and_Timeline.controls['totalTarget']?.value
          }

          if (obj.proposedDateTraining != '' && obj.proposedDistrict != '' && obj.proposedVenue != ''
            && obj.proposedNoOfWorkshop != '' && obj.totalTarget != null && obj.proposedNoOfWorkshop >= 1 && obj.totalTarget != '' && obj.totalTarget >= 1) {
            //const data = this.district_help.filter(x => x.id === obj['proposedDistrict']);
            //obj['districtName'] = data[0]['text'];

            

            const data = this.district_help.find(x => x.id == obj['proposedDistrict']);
            obj['districtName'] = data ? data.text : null; // Prevents an error if no match is found

            const isDuplicate = this.Geography_and_Timeline_submitList.some(item =>
              item.proposedDateTraining === obj.proposedDateTraining &&
              item.proposedDistrict === obj.proposedDistrict &&
              item.proposedVenue === obj.proposedVenue &&
              item.proposedNoOfWorkshop === obj.proposedNoOfWorkshop &&
              item.totalTarget === obj.totalTarget
            );

            if (isDuplicate && status !== 'delete') {
              this.toastrService.error('Duplicate Record Found!', 'Record Found!');
              return;
            }

            if (status == 'submit') {
              this.Geography_and_Timeline_submitList.push(obj);

              this.Geography_and_Timeline.get('proposedDateTraining')?.setValue('');
              this.Geography_and_Timeline.get('proposedDistrict')?.setValue('');
              this.Geography_and_Timeline.get('proposedVenue')?.setValue('');
              this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.setValue('');
              this.Geography_and_Timeline.get('totalTarget')?.setValue('');
              this.hiddenProposalId = 0;
              let localStorage_Implementation_Details_submitList = JSON.stringify(this.Geography_and_Timeline_submitList)
              localStorage.setItem("localStorage_Geography_and_Timeline_submitList_submitList", localStorage_Implementation_Details_submitList)
              this.currentStep = 4;
              this.Training_DeliverySubmitted = false;
              this.isBtnEdit = false;
              this.isBtnDelete = false;
              if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
                this.isTotalTargetMSMECount = true;
                this.Geography_and_Timeline.disable();
                this.isTargetGeo = false;
                this.isBtnNextGeo = false;
                this.isBtnAddGeo = true;
              }
            }
            else {
              this.currentStep = 3;
              this.Geography_and_Timeline_submitList.push(obj);
              this.minDate = new Date();
              this.minDate.setDate(this.minDate.getDate() + 1);
              this.Geography_and_Timeline.get('id')?.patchValue('');
              this.Geography_and_Timeline.get('proposedDateTraining')?.patchValue('');
              this.Geography_and_Timeline.get('proposedDistrict')?.patchValue('');
              this.Geography_and_Timeline.get('proposedVenue')?.patchValue('');
              this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.patchValue('');
              this.Geography_and_Timeline.get('totalTarget')?.patchValue('');
              this.hiddenProposalId = 0;
              this.Geography_and_Timeline.controls['proposedDistrict'].setValue(null);
              this.Geography_and_TimelineSubmitted = false;
              this.isBtnEdit = false;
              this.isBtnDelete = false;
              //this.isBtnNext = false;
              this.isTargetGeo = true;
              if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
                this.isTotalTargetMSMECount = true;
                this.Geography_and_Timeline.disable();
                this.isTargetGeo = false;
                this.isBtnNextGeo = false;
                this.isBtnAddGeo = true;
              }
            }
          }
          else if (status == 'addmore') {
            if (this.Implementation_Details.valid) {
              this.ignoreGeoTimelineValidator(false, '');
              this.minDate = new Date();
              this.minDate.setDate(this.minDate.getDate() + 1);
              this.isBtnEdit = false;
              this.isBtnDelete = false;
              //this.isBtnNext = false;
              if (this.maxTargetMSME == parseInt(this.TotalTargetMSMECount)) {
                this.isTotalTargetMSMECount = true;
                this.Geography_and_Timeline.disable();
              }
            }
          }
          //added for edit functionality
          else if (status == 'edit') {
            //this.minDate.setDate(this.minDate.getDate() + 1);

            const dateString = this.Geography_and_Timeline_submitList[i].proposedDateTraining; // '08/01/2025'
            const [day, month, year] = dateString.split('/').map(Number);
            const date = new Date(year, month - 1, day); // Convert dd/MM/yyyy to Date object
            this.Geography_and_Timeline.get('proposedDateTraining')?.setValue(date);

            // Set minDate to the same date
            this.minDate = new Date(date); // Clone the date to minDate
            const min = new Date(date);
            //const max = new Date(proposalDate[1]);
            const currentDate = new Date();
            if (min > currentDate) {
              this.minDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
            } else {
              this.minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
            }


            /*this.Geography_and_Timeline.get('proposedDateTraining')?.setValue(this.Geography_and_Timeline_submitList[i].proposedDateTraining);*/
            this.Geography_and_Timeline.get('proposedDistrict')?.setValue(this.Geography_and_Timeline_submitList[i].proposedDistrict.toString());
            this.Geography_and_Timeline.get('proposedVenue')?.setValue(this.Geography_and_Timeline_submitList[i].proposedVenue);
            this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.setValue(this.Geography_and_Timeline_submitList[i].proposedNoOfWorkshop);
            this.Geography_and_Timeline.get('totalTarget')?.setValue(this.Geography_and_Timeline_submitList[i].totalTarget);
            this.hiddenProposalId = this.Geography_and_Timeline_submitList[i].id
            this.Geography_and_TimelineSubmitted = false;
            this.Geography_and_Timeline_submitList.splice(i, 1);
            this.isBtnEdit = true;
            this.isBtnDelete = true;
            this.isBtnNextGeo = true;
            this.isTotalTargetMSMECount = false;
            this.isBtnAddGeo = false;
            this.isTargetGeo = true;
            this.Geography_and_Timeline.enable();
          }
          else if (status == 'delete') {
            this.openConfirmationDialog('GeoTime', i);
          }
          else if (status == 'submit') {
            let localStorage_Implementation_Details_submitList = JSON.stringify(this.Geography_and_Timeline_submitList)
            localStorage.setItem("localStorage_Geography_and_Timeline_submitList_submitList", localStorage_Implementation_Details_submitList)
            this.currentStep = 4;
            this.Training_DeliverySubmitted = false;
            this.isBtnEdit = false;
            this.isBtnDelete = false;
          }
        }
        else {
          if (status == 'delete') {
            this.openConfirmationDialog('GeoTime', i);
          }
        }
        //console.log(this.Geography_and_Timeline_submitList);
      }
    }
    else if (status == 'delete') {
      this.openConfirmationDialog('GeoTime', i);
    }
    else if (status == 'edit') {
      //this.minDate.setDate(this.minDate.getDate() + 1);

      const dateString = this.Geography_and_Timeline_submitList[i].proposedDateTraining; // '08/01/2025'
      const [day, month, year] = dateString.split('/').map(Number);
      const date = new Date(year, month - 1, day); // Convert dd/MM/yyyy to Date object
      this.Geography_and_Timeline.get('proposedDateTraining')?.setValue(date);

      // Set minDate to the same date
      this.minDate = new Date(date); // Clone the date to minDate
      const min = new Date(date);
      //const max = new Date(proposalDate[1]);
      const currentDate = new Date();
      if (min > currentDate) {
        this.minDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
      } else {
        this.minDate = new Date(min.getFullYear(), min.getMonth(), min.getDate());
      }



      /*this.Geography_and_Timeline.get('proposedDateTraining')?.setValue(this.Geography_and_Timeline_submitList[i].proposedDateTraining);*/
      this.Geography_and_Timeline.get('proposedDistrict')?.setValue(this.Geography_and_Timeline_submitList[i].proposedDistrict);
      this.Geography_and_Timeline.get('proposedVenue')?.setValue(this.Geography_and_Timeline_submitList[i].proposedVenue);
      this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.setValue(this.Geography_and_Timeline_submitList[i].proposedNoOfWorkshop);
      this.Geography_and_Timeline.get('totalTarget')?.setValue(this.Geography_and_Timeline_submitList[i].totalTarget);
      this.hiddenProposalId = this.Geography_and_Timeline_submitList[i].id
      this.Geography_and_TimelineSubmitted = false;
      this.Geography_and_Timeline_submitList.splice(i, 1);
      this.isBtnEdit = true;
      this.isBtnDelete = true;
      this.isBtnAddGeo = false;
      //this.isBtnNext = true;
      this.isTotalTargetMSMECount = false;
      this.isTargetGeo = true;
      this.Geography_and_Timeline.enable();
    }
    else if (this.Geography_and_Timeline.controls['totalTarget']?.value > this.maxTargetMSME) {
      this.isBtnAddGeo = true;
      this.isBtnEdit = true;
      this.isBtnDelete = true;
      this.isTotalTargetMSMECount = false;
    }
    else {
      if (this.Geography_and_Timeline.valid) {
        this.isBtnAddGeo = true;
        this.isBtnEdit = true;
        this.isBtnDelete = true;
        this.isTotalTargetMSMECount = true;
      }
    }
  }

  ChkGeographyandTimeline() {
    this.maxTargetMSME = this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value;
    this.TotalTargetMSMECount = this.Geography_and_Timeline_submitList.reduce((sum, row) => sum + row.totalTarget, 0) + this.Geography_and_Timeline.controls['totalTarget']?.value;

    if (parseInt(this.TotalTargetMSMECount) > this.maxTargetMSME && this.Geography_and_Timeline_submitList.length > 0) {
      this.isTotalTargetMSMECount = true;
    }
    //else if (parseInt(this.TotalTargetMSMECount) == this.maxTargetMSME) {
    //  this.isBtnNextGeo = true;
    //}
    else {
      this.isTotalTargetMSMECount = false;
    }
  }

  Training_Delivery_submit() {
    this.Training_DeliverySubmitted = true;
    if (this.currentStep === 4) {
      if (this.Training_Delivery.valid) {
        this.currentStep = 5;
        this.DetailedFinancialsSubmitted = false;
        this.loadDetailedFinancials_Submit();
      } else {
        // Handle invalid form case (e.g., show an error message)
      }
    }
  }

  //loadDetailedFinancials_Submit() {
  //  const interventionId = this.Implementing_Agency_DetailsForm.get('interventionId')?.value;
  //  const targetMSME = this.Implementing_Agency_DetailsForm.get('targetMSME')?.value;

  //  if (interventionId != null && targetMSME != null) {
  //    this.DetailedFinancials.patchValue({
  //      budgetHeadId: interventionId,
  //      cost: targetMSME * this.BudgetPerBeneficiary
  //    });
  //  }
  //}

  loadDetailedFinancials_Submit() {
    this.DetailedFinancials.patchValue({
      budgetHeadId: this.Implementing_Agency_DetailsForm.controls['interventionId']?.value,
      cost: +(this.Implementing_Agency_DetailsForm.controls['targetMSME']?.value * this.BudgetPerBeneficiary).toFixed(2)
    });    
  }

  DetailedFinancials_Submit(status: any, i: any) {
    this.DetailedFinancialsSubmitted = true;
    if (this.currentStep === 5) {
      if (this.DetailedFinancials.valid) {

        if (this.hiddenProposalId !== null && this.hiddenProposalId !== undefined && this.hiddenProposalId !== 0)
          this.DetailedFinancials.get('id')?.setValue(this.hiddenProposalId);
        else
          this.DetailedFinancials.get('id')?.setValue(0);

        var obj: any = {
          "id": parseInt(this.DetailedFinancials.controls['id']?.value) || 0,
          "budgetHeadId": parseInt(this.DetailedFinancials.controls['budgetHeadId']?.value),
          "cost": parseFloat(this.DetailedFinancials.controls['cost']?.value)
        }

        if (!isNaN(obj.budgetHeadId) && !isNaN(obj.cost) && obj.cost > 0) {
          const data = this.budgetHead_help.find(x => x.id == obj['budgetHeadId']);
          obj['interventionName'] = data ? data.text : ''; // Provide a default value if no match is found

          //const data = this.budgetHead_help.filter(x => x.id === obj['budgetHeadId']);
          //obj['interventionName'] = data[0]['text'];

          //const isDuplicate = this.DetailedFinancials_submitList.some(item =>
          //  //item.id === obj.id &&
          //  item.budgetHeadId === obj.budgetHeadId &&
          //  item.cost === obj.cost
          //);

          //if (isDuplicate && status !== 'delete') {
          //  this.toastrService.error('Duplicate Record Found!', 'Record Found!');
          //  return;
          //}

          if (status == 'submit') {
            this.DetailedFinancials_submitList = [];
            this.DetailedFinancials_submitList.push(obj);

            //this.DetailedFinancials.get('budgetHeadId')?.setValue('');
            //this.DetailedFinancials.get('cost')?.setValue('');
            this.hiddenProposalId = 0;
            let localStorage_BeneficiariesAndOther_submitList = JSON.stringify(this.DetailedFinancials_submitList)
            localStorage.setItem("localStorage_BeneficiariesAndOther_submitList", localStorage_BeneficiariesAndOther_submitList)
            this.currentStep = 6;
            this.Intervention_MilestonesSubmitted = false;
            this.isBtnEdit = false;
            this.isBtnDelete = false;
            //if (this.Intervention_Milestones_submitList.length == 0) {
            //  this.isHiddenUpdate = true;
            //  //this.isHiddenSubmit = true;
            //}
   
            const selectedValue = parseInt(this.Implementing_Agency_DetailsForm.controls['componentId']?.value);
            this.selectedText = this.Component_help.find(item => item.id == selectedValue)?.text || '';
            this.Intervention_MilestonesForm.controls['milestone'].setValue(this.selectedText);

            //const selectedValue = parseInt(this.Implementing_Agency_DetailsForm.controls['interventionId']?.value, 10) || 0;

            //const selectedItem = this.Intervention_help.find(item => item.id == selectedValue);
            //this.selectedText = selectedItem ? selectedItem.text : '';

            if (this.Intervention_MilestonesForm.controls['milestone']) {
              this.Intervention_MilestonesForm.controls['milestone'].setValue(this.selectedText);
            }


          }
          else if (status == 'delete') {
            this.openConfirmationDialog('DetFin', i);
          }
          else {
            this.currentStep = 5;
            this.DetailedFinancials_submitList.push(obj);
            this.DetailedFinancials.get('id')?.patchValue('');
            this.DetailedFinancials.get('budgetHeadId')?.patchValue('');
            this.DetailedFinancials.get('cost')?.patchValue('');
            this.hiddenProposalId = 0;
            this.DetailedFinancialsSubmitted = false;
            this.isBtnEdit = false;
            this.isBtnDelete = false;
          }
        }
        else if (status == 'edit') {
          this.DetailedFinancials.get('budgetHeadId')?.setValue(this.DetailedFinancials_submitList[i].budgetHeadId);
          this.DetailedFinancials.get('cost')?.setValue(this.DetailedFinancials_submitList[i].cost);
          this.hiddenProposalId = this.DetailedFinancials_submitList[i].id
          this.DetailedFinancialsSubmitted = false;
          this.DetailedFinancials_submitList.splice(i, 1);
          this.isBtnEdit = true;
          this.isBtnDelete = true;
        }
        else if (status == 'delete') {
          this.openConfirmationDialog('DetFin', i);
        }
        else if (status == 'submit') {
          let localStorage_BeneficiariesAndOther_submitList = JSON.stringify(this.DetailedFinancials_submitList)
          localStorage.setItem("localStorage_BeneficiariesAndOther_submitList", localStorage_BeneficiariesAndOther_submitList)
          this.currentStep = 6;
          this.Intervention_MilestonesSubmitted = false;
          this.isBtnEdit = false;
          this.isBtnDelete = false;
          //if (this.Intervention_Milestones_submitList.length == 0) {
          //  this.isHiddenUpdate = true;
          //  //this.isHiddenSubmit = true;
          //} 
        }
      } else {
        if (status == 'delete') {
          this.openConfirmationDialog('DetFin', i);
        }
      }
      if (sessionStorage.getItem('storeFileName') != '') {
        this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.setValue(sessionStorage.getItem('storeFileName'));
      }
    }
  }

  Intervention_Milestones_submit(status: any, i: any) {
    this.Intervention_MilestonesSubmitted = true;
    if (this.currentStep === 6) {
      if (this.Intervention_MilestonesForm.valid) {
        if (status == 'submit') {
          this.checkValidateMilstoneDetails();
          if (this.Intervention_MilestonesForm.get('milestone')?.value != '' &&
            this.Intervention_MilestonesForm?.value.projectStartDate != '' &&
            this.Intervention_MilestonesForm?.value.durationInMonth != '' &&
            this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {

            //if (this.Intervention_MilestonesForm?.value.id === '') {
            //  this.Intervention_MilestonesForm?.value.id = parseInt(this.Implementation_Details.controls['id']?.value) || 0;
            //}
            //this.Intervention_MilestonesForm.controls['milestone'].setValue(this.selectedText);

            if (this.hiddenProposalId !== null && this.hiddenProposalId !== undefined && this.hiddenProposalId !== 0)
              this.Intervention_MilestonesForm.get('id')?.setValue(this.hiddenProposalId);
            else
              this.Intervention_MilestonesForm.get('id')?.setValue(0);

            if (status == 'submit' && !this.isDuplicateMilstone) {
              if (this.Intervention_MilestonesForm?.value.projectStartDate != '') {
                var projectStartDate = this.Intervention_MilestonesForm?.value.projectStartDate;
                projectStartDate = this.datePipe.transform(projectStartDate, 'dd/MM/yyyy');
                this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(projectStartDate);
              }

              if (this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {
                var estimatedProjectClosureDate = this.Intervention_MilestonesForm?.value.estimatedProjectClosure;
                estimatedProjectClosureDate = this.datePipe.transform(estimatedProjectClosureDate, 'dd/MM/yyyy');
                this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(estimatedProjectClosureDate);
              }

              this.Intervention_Milestones_submitList.push(this.Intervention_MilestonesForm?.value);
              let localStorage_Intervention_Milestones_submitList = JSON.stringify(this.Intervention_Milestones_submitList);
              localStorage.setItem("localStorage_Intervention_Milestones_submitList", localStorage_Intervention_Milestones_submitList);
              this.hiddenProposalId = 0;
              //this.isHiddenSubmit = true;
              //this.isHiddenUpdate = true;
              this.submitForms();
              this.DetailedFinancialsSubmitted = false;
              //['milestone', 'projectStartDate', 'durationInMonth', 'estimatedProjectClosure']
              //  .forEach(field => this.Intervention_MilestonesForm.get(field)?.patchValue(''));
              this.isBtnEdit = false;
              this.isBtnDelete = false;
            }
          }
          else {
            this.Intervention_MilestonesSubmitted = true;
            this.InterventionMilstone();
          }
        }
        else if (status == 'edit') {
          //this.Intervention_MilestonesForm.get('milestone')?.setValue(this.Intervention_Milestones_submitList[i].milestone);
          const getProjectStartDate = this.Intervention_Milestones_submitList[i].projectStartDate; // '08/01/2025'
          const [day, month, year] = getProjectStartDate.split('/').map(Number);
          const dateProjectStart = new Date(year, month - 1, day); // Convert dd/MM/yyyy to Date object
          this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(dateProjectStart);
          // Set minDate to the same date
          this.proposalSelectedDate = new Date(dateProjectStart); // Clone the date to minDate


          //this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(this.Intervention_Milestones_submitList[i].projectStartDate);
          this.Intervention_MilestonesForm.get('durationInMonth')?.setValue(this.Intervention_Milestones_submitList[i].durationInMonth);
          const getestimatedProjectClosure = this.Intervention_Milestones_submitList[i].estimatedProjectClosure; // '08/01/2025'
          const [days, months, years] = getestimatedProjectClosure.split('/').map(Number);
          const dateestimatedProjectClosure = new Date(years, months - 1, days); // Convert dd/MM/yyyy to Date object
          this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(dateestimatedProjectClosure);
          //this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(this.Intervention_Milestones_submitList[i].estimatedProjectClosure);
          this.hiddenProposalId = this.Intervention_Milestones_submitList[i].id;
          this.Intervention_MilestonesSubmitted = false;
          this.Intervention_MilestonesForm.enable();
          this.isUploadProposalCertificate = false;
          this.isBtnEdit = true;
          this.isBtnDelete = true;
          this.isBtnAddMile = false;
          this.Intervention_Milestones_submitList.splice(i, 1);
        }
        else if (status == 'delete') {
          this.openConfirmationDialog('InterMile', i);          
        }
        else if (status == 'addmore') {
          this.currentStep = 6;
          this.checkValidateMilstoneDetails();
          //if (this.Intervention_MilestonesForm?.value.id === '') {
          //  this.Intervention_MilestonesForm?.value.id = parseInt(this.Implementation_Details.controls['id']?.value) || 0;
          //}
          if (this.hiddenProposalId !== null && this.hiddenProposalId !== undefined && this.hiddenProposalId !== 0)
            this.Intervention_MilestonesForm.get('id')?.setValue(this.hiddenProposalId);
          else
            this.Intervention_MilestonesForm.get('id')?.setValue(0);

          if (this.Intervention_MilestonesForm?.value.projectStartDate != '') {
            var projectStartDate = this.Intervention_MilestonesForm?.value.projectStartDate;
            projectStartDate = this.datePipe.transform(projectStartDate, 'dd/MM/yyyy');
            this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(projectStartDate);
          }

          this.proposalStartDate = new Date();
          this.proposalStartDate.setDate(this.proposalStartDate.getDate() + 1);

          if (this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {
            var estimatedProjectClosure = this.Intervention_MilestonesForm?.value.estimatedProjectClosure;
            estimatedProjectClosure = this.datePipe.transform(estimatedProjectClosure, 'dd/MM/yyyy');
            this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(estimatedProjectClosure);
          }

          this.proposalSelectedDate = new Date();
          this.proposalSelectedDate.setDate(this.proposalSelectedDate.getDate() + 1);

         

          if (status == 'addmore' && !this.isDuplicateMilstone) {
            this.Intervention_Milestones_submitList.push(this.Intervention_MilestonesForm?.value); 
            this.hiddenProposalId = 0;            
            this.Intervention_MilestonesSubmitted = false;
            this.isBtnEdit = false;
            this.isBtnDelete = false;
            //if (this.Intervention_Milestones_submitList.length > 0)
            //  this.isHiddenUpdate = false;
            //this.isHiddenSubmit = false;
          }
          this.isBtnAddMile = true;
        }
      }
      else {
        if (status == 'delete') {
          this.openConfirmationDialog('InterMile', i);          
        }
        else if (status == 'edit') {
          //this.Intervention_MilestonesForm.get('milestone')?.setValue(this.Intervention_Milestones_submitList[i].milestone);
          const getProjectStartDate = this.Intervention_Milestones_submitList[i].projectStartDate; // '08/01/2025'
          const [day, month, year] = getProjectStartDate.split('/').map(Number);
          const dateProjectStart = new Date(year, month - 1, day); // Convert dd/MM/yyyy to Date object
          this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(dateProjectStart);

          // Set minDate to the same date
          this.proposalStartDate = new Date(dateProjectStart); // Clone the date to minDate

          /*this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(this.Intervention_Milestones_submitList[i].projectStartDate);*/
          this.Intervention_MilestonesForm.get('durationInMonth')?.setValue(this.Intervention_Milestones_submitList[i].durationInMonth);
          //this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(this.Intervention_Milestones_submitList[i].estimatedProjectClosure);

          const getestimatedProjectClosure = this.Intervention_Milestones_submitList[i].estimatedProjectClosure; // '08/01/2025'
          const [days, months, years] = getestimatedProjectClosure.split('/').map(Number);
          const dateestimatedProjectClosure = new Date(years, months - 1, days); // Convert dd/MM/yyyy to Date object
          this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(dateestimatedProjectClosure);


          // Set minDate to the same date
          this.proposalSelectedDate = new Date(dateestimatedProjectClosure); // Clone the date to minDate

          this.hiddenProposalId = this.Intervention_Milestones_submitList[i].id
          this.Intervention_MilestonesSubmitted = false;
          this.Intervention_Milestones_submitList.splice(i, 1);
          this.isBtnEdit = true;
          this.isBtnDelete = true;
          this.isBtnAddMile = false;
          this.Intervention_MilestonesForm.enable();
          this.isUploadProposalCertificate = false;
        }
        else if (status == 'submit') {
          this.isBtnEdit = false;
          this.isBtnDelete = false;
          //this.isHiddenSubmit = true;
          //this.isHiddenUpdate = true;
          if (this.Intervention_Milestones_submitList.length > 0)           
            this.InterventionMilstone();
        }        
      }     
    }    
  }

  checkValidateMilstoneDetails() {
    if (this.Intervention_MilestonesForm?.value.milestone != '' &&
      this.Intervention_MilestonesForm?.value.projectStartDate != '' &&
      this.Intervention_MilestonesForm?.value.durationInMonth != '' &&
      this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {

      if (this.Intervention_MilestonesForm?.value.projectStartDate != '') {
        var projectStartDate = this.Intervention_MilestonesForm?.value.projectStartDate;
        projectStartDate = this.datePipe.transform(projectStartDate, 'yyyy-MM-dd');
        this.Intervention_MilestonesForm.get('projectStartDate')?.setValue(projectStartDate);
      }

      if (this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {
        var estimatedProjectClosure = this.Intervention_MilestonesForm?.value.estimatedProjectClosure;
        estimatedProjectClosure = this.datePipe.transform(estimatedProjectClosure, 'yyyy-MM-dd');
        this.Intervention_MilestonesForm.get('estimatedProjectClosure')?.setValue(estimatedProjectClosure);
      }

      this.isDuplicateMilstone = this.Intervention_Milestones_submitList.some(item =>
        item.milestone === this.Intervention_MilestonesForm?.value.milestone &&
        item.projectStartDate === this.Intervention_MilestonesForm?.value.projectStartDate &&
        item.durationInMonth === this.Intervention_MilestonesForm?.value.durationInMonth &&
        item.estimatedProjectClosure === this.Intervention_MilestonesForm?.value.estimatedProjectClosure
      );

      if (this.isDuplicateMilstone) {
        this.toastrService.error('Duplicate Record Found!', 'Record Found!');
        return;
      }
    }
  }

  InterventionMilstone() {
    this.ignoreValidator();
    let localStorage_Intervention_Milestones_submitList = JSON.stringify(this.Intervention_Milestones_submitList)
    localStorage.setItem("localStorage_Intervention_Milestones_submitList", localStorage_Intervention_Milestones_submitList)
    //this.isHiddenSubmit = true;
    //this.isHiddenUpdate = true;
    this.submitForms();
  }

  getintervention_help(e: any) {
    const UserId = e;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.Fund.GET_intervention_help, { getUserId: UserId }).subscribe(
      (response: any) => {
        this.Intervention_help = response.status ? response.data : (this.toastrService.error('Error fetching intervention data', 'Oops...'), null);
        this.budgetHead_help = this.Intervention_help;

      },
      (error: any) => {
        this.toastrService.error('Error fetching intervention data', 'Oops...');
      }
    );
  }

  getIAProfile_help(e: any) {
    const UserId = e;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.Fund.GET_iaprofiledetails_help, { getUserId: UserId }).subscribe(
      (response: any) => {
        this.BriefBackgroundIA = response.data['briefBackgroundIA'];
        this.SummaryScaleIA = response.data['summaryScaleIA'];

        //this.Implementing_Agency_DetailsForm.get('bbImplementAgency')?.setValue('bbImplementAgency');
        //this.Implementing_Agency_DetailsForm.get('ssProjectImplementAgency')?.setValue('ssProjectImplementAgency');

        this.Implementing_Agency_DetailsForm.get('bbImplementAgency')?.setValue(this.BriefBackgroundIA);
        this.Implementing_Agency_DetailsForm.get('ssProjectImplementAgency')?.setValue(this.SummaryScaleIA);
      },
      (error: any) => {
        this.toastrService.error('Error fetching My date data', 'Oops...');
      }
    );
  }

  GetComponent(e: any, action: string) {
    
    var Interventionid;
    if (action == 'select')
      Interventionid = e.id;
      /*Interventionid = e.target?.value;*/
    else
      Interventionid = e;

    if (Interventionid != '') {
      this.enableDropdown();
      this.Implementing_Agency_DetailsForm.controls['componentId'].setValue(null);
      const UserId = sessionStorage.getItem("iauserid") || '';
      var getComponent = { Interventionid: Interventionid, UserId: UserId, ProposalUserId: this.proposalUserId !== undefined ? this.proposalUserId : "" }
      this.apiService.getRequest(API_ENDPOINTS.MASTERS.Fund.GET_component_help, getComponent).subscribe(
        (response: any) => {
          response.status ?
            (this.Component_help = response.data) : this.toastrService.error('Error fetching Component data', 'Oops...');
        },
        (error: any) => {
          this.toastrService.error('Error fetching Component data', 'Oops...');
        }
      );
      //this.apiService.getRequest(API_ENDPOINTS.MASTERS.Fund.GET_componentDetails_help, getComponent).subscribe(
      //  (response: any) => {
      //    response.status ?
      //      (this.Component_help = response.data) : this.toastrService.error('Error fetching Component data', 'Oops...');
      //  },
      //  (error: any) => {
      //    this.toastrService.error('Error fetching Component data', 'Oops...');
      //  }
      //);
    }
    else {
      this.Implementing_Agency_DetailsForm.get('componentId')?.setValue('');
      this.Implementing_Agency_DetailsForm.get('approved_Budget')?.setValue('');
      this.Implementing_Agency_DetailsForm.get('rate_per_Beneficiary_MSME')?.setValue('');
      this.disableDropdown();
    }
  }

  Getdistrict() {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETDistrictHelp).subscribe(
      (response: any) => {

        response.status ?
          (this.district_help = response.data) : this.toastrService.error('Error fetching district data', 'Oops...');
      },
      (error: any) => {
        this.toastrService.error('Error fetching district data', 'Oops...');
      }
    );
  }

  prev() {
    this.currentStep--;
    if (this.currentStep == 2) {
      this.ignoreEngagePartnerNameValidator(true, 'prev');
      this.ChkImplementationDetails();
    }
    else if (this.currentStep == 3) {
      this.ignoreGeoTimelineValidator(true, 'prev');
      this.ChkGeographyandTimeline();
    }
    else if (this.currentStep == 5) {
      //this.fileName = ''; 
      //this.ignoreDetailedFinancialsValidator(true, 'prev');
    }    
  }

  preventPaste = true;
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  onPaste($event: ClipboardEvent) {
    if (this.preventPaste) {
      $event.preventDefault();
    }
  }


  GetApprovedBudgetTargetMSME(val: any) {
    const button = document.getElementById('ImplementAgency') as HTMLButtonElement;
    //this.Implementing_Agency_DetailsForm.get('approved_Budget')?.setValue('');
    //this.Implementing_Agency_DetailsForm.get('targetMSME')?.setValue(''); //rate_per_Beneficiary_MSME
    this.Implementing_Agency_DetailsForm.get('rate_per_Beneficiary_MSME')?.setValue('');
    var data = {
      InterventionId: this.Implementing_Agency_DetailsForm.get('interventionId')?.value,
      ComponentId: this.Implementing_Agency_DetailsForm.get('componentId')?.value,
    }
    if (data.InterventionId != '' && data.ComponentId != '') {
      this.apiService.getRequest(API_ENDPOINTS.IA.GETTARGETMSME, data).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.maxBudget = response.data[0]['ApprovedBudget'] || 0;
            this.minMSME = 1;
            this.maxMSME = response.data[0]['TotalTargetMSME'] || 0;
            
            // Update the validator with the new max value
            this.f['targetMSME'].setValidators([
              Validators.required,
              Validators.max(this.maxMSME),
            ]);

            this.isDisabled = false;
            // Re-validate the control
            this.f['targetMSME'].updateValueAndValidity();            
            this.remainingTargetMSME = "Remaning Target MSME Value : " + this.maxMSME;
            if (this.maxMSME == 0) {
              this.isDisabled = true;
              this.ignoreFormValidator(true);
            }
            else {
              this.isDisabled = false;
              this.ignoreFormValidator(false);
            }
            if (response.data[0]?.BudgetPerBeneficiary !== null && response.data[0]?.BudgetPerBeneficiary !== undefined) {
              this.BudgetPerBeneficiary = +(response.data[0].BudgetPerBeneficiary).toFixed(2);
              this.Implementing_Agency_DetailsForm.get('rate_per_Beneficiary_MSME')?.setValue(this.BudgetPerBeneficiary);
              this.isDisabled = false;
            } else {
              this.BudgetPerBeneficiary = null;
              this.toastrService.info("Rate per Beneficiary MSME amount should not be empty. Please contact support for assistance.");
              this.isDisabled = true;
            }
            //this.BudgetPerBeneficiary = +(response.data[0]['BudgetPerBeneficiary']).toFixed(2) || 0;
          }
          else {
            this.isDisabled = true;
            this.toastrService.info("Funds are missing for the selected interest. Please add funds or contact support for assistance.");
          }
        },
        (error: any) => {
          this.toastrService.error('Approved Budget and Target MSME are not availabe');
        }
      );
    }
  }

  ignoreValidator() {
    const milestone = this.Intervention_MilestonesForm.get('milestone');
    const projectStartDate = this.Intervention_MilestonesForm.get('projectStartDate');
    const durationInMonth = this.Intervention_MilestonesForm.get('durationInMonth');
    const estimatedProjectClosure = this.Intervention_MilestonesForm.get('estimatedProjectClosure');
    const uploadProposalCertificate = this.Intervention_MilestonesForm.get('uploadProposalCertificate'); // New Field

    // Remove validators
    milestone?.clearValidators();
    projectStartDate?.clearValidators();
    durationInMonth?.clearValidators();
    estimatedProjectClosure?.clearValidators();
    uploadProposalCertificate?.clearValidators(); // Clear validator for new field

    // Update value and validity
    milestone?.updateValueAndValidity();
    projectStartDate?.updateValueAndValidity();
    durationInMonth?.updateValueAndValidity();
    estimatedProjectClosure?.updateValueAndValidity();
    uploadProposalCertificate?.updateValueAndValidity(); // Update validity for new field
  }

  restrictNumericInput(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    // Disallow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
  }

  //Delete Functionality Code Start
  openConfirmationDialog(type: string, index: number): void {
    // Pass the type and index to the dialog for dynamic action handling
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      //data: { type, index }
      data: { message: 'Do you want to delete the record?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Based on the type, call the respective remove function
        switch (type) {
          case 'ImpDetails':
            this.removeImpDetails(index);
            if (this.Implementation_Details_submitList.length == 0) {
              this.ignoreEngagePartnerNameValidator(false, '');
            }
            this.ChkImplementationDetails();          
            if (parseInt(this.TotalTargetMSMECount) < this.maxTargetMSME) {
              this.Implementation_Details.enable();
              this.isBtnNext = true;
              this.isTarget = true;
            }
            else if (parseInt(this.TotalTargetMSMECount) == this.maxTargetMSME) {
              this.Implementation_Details.disable();
              this.isBtnNext = false;
              this.isBtnAdd = true;
              this.isTarget = false;
            }
            break;
          case 'GeoTime':
            this.removeGeoTime(index);
            if (this.Geography_and_Timeline_submitList.length == 0) {
              this.ignoreGeoTimelineValidator(false, '');
            }
            this.ChkGeographyandTimeline();
            if (parseInt(this.TotalTargetMSMECount) < this.maxTargetMSME) {
              this.ignoreGeoTimelineValidator(false, '');
              this.Geography_and_Timeline.enable();
              this.isBtnNextGeo = true;
              this.isTargetGeo = true;              
            }
            else if (parseInt(this.TotalTargetMSMECount) == this.maxTargetMSME) {
              this.Geography_and_Timeline.disable();
              this.isBtnNextGeo = false;
              this.isBtnAddGeo = true;
              this.isTargetGeo = false;
            }
            break;
          case 'DetFin':
            this.removeDetFin(index);
            if (this.DetailedFinancials_submitList.length == 0) {
              this.ignoreDetailedFinancialsValidator(false, '');
            }
            break;
          case 'InterMile':
            this.removeInterMile(index);
            this.Intervention_MilestonesForm.enable();
            this.isUploadProposalCertificate = false;
            //this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.enable();
            //if (this.Intervention_Milestones_submitList.length == 0) {
            //  this.isHiddenUpdate = true;
            //  this.isHiddenSubmit = true;
            //} 
            break;
        }
      }
    });

    
  }
  removeImpDetails(index: number) {
    this.Implementation_DetailsSubmitted = false;
    this.Implementation_Details_submitList.splice(index, 1);
  }
  removeGeoTime(index: number) {
    this.Geography_and_TimelineSubmitted = false;
    this.Geography_and_Timeline_submitList.splice(index, 1);
  }
  removeDetFin(index: number) {
    this.DetailedFinancialsSubmitted = false;
    this.DetailedFinancials_submitList.splice(index, 1);
  }
  removeInterMile(index: number) {
    this.Intervention_MilestonesSubmitted = false;
    this.Intervention_Milestones_submitList.splice(index, 1);
  }
  //Delete Functionality Code End


  ignoreFormValidator(condition: boolean) {
    
    const controlsToManage = [
      'interventionId',
      'componentId',
      'targetMSME',
      'noOfEvent',
      'rate_per_Beneficiary_MSME',
      'pragramNameConduct',
      'measurableOutcomes'
    ];

    controlsToManage.forEach(controlName => {
      const control = this.Implementing_Agency_DetailsForm.get(controlName);

      if (condition) {
        
        // Remove all validators
        control?.clearValidators();
        control?.updateValueAndValidity();
      } else {
        
        // Enable required validators
        this.Implementing_Agency_DetailsForm.get('interventionId')?.setValidators([Validators.required]);
        this.Implementing_Agency_DetailsForm.get('componentId')?.setValidators([Validators.required]);
        this.Implementing_Agency_DetailsForm.get('targetMSME')?.setValidators([Validators.required, Validators.min(1), Validators.max(this.maxMSME)]);
        this.Implementing_Agency_DetailsForm.get('rate_per_Beneficiary_MSME')?.setValidators([Validators.required]);
        this.Implementing_Agency_DetailsForm.get('noOfEvent')?.setValidators([Validators.required, Validators.min(1), Validators.maxLength(3)]);
        this.Implementing_Agency_DetailsForm.get('pragramNameConduct')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]);
        this.Implementing_Agency_DetailsForm.get('measurableOutcomes')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]);
        //control?.setValidators([Validators.required]); // Add required validator or others as needed

        // Update validation state
        this.Implementing_Agency_DetailsForm.get('interventionId')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('componentId')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('targetMSME')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('noOfEvent')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('rate_per_Beneficiary_MSME')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('pragramNameConduct')?.updateValueAndValidity();
        this.Implementing_Agency_DetailsForm.get('measurableOutcomes')?.updateValueAndValidity();
      }
      // Update validation state
      //control?.updateValueAndValidity();
    });
  }

  disableDropdown() {
    this.Implementing_Agency_DetailsForm.get('componentId')?.disable();
  }

  enableDropdown() {
    this.Implementing_Agency_DetailsForm.get('componentId')?.enable();
  }

  ignoreEngagePartnerNameValidator(condition: boolean, action: string) {
    const controlsToManage = [
      'engagementPartnerName',
      'districtId',
      'noOfWorkshop',
      'targets'
    ];

    controlsToManage.forEach(controlName => {
      const control = this.Implementation_Details.get(controlName);

      if (condition && action=="prev") {
        // Remove all validators
        control?.clearValidators();
        control?.updateValueAndValidity();
      } else {
        // Enable required validators
        this.Implementation_Details.get('engagementPartnerName')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(150), Validators.pattern(this.commonService.nameOfOrganisation)]);
        this.Implementation_Details.get('districtId')?.setValidators([Validators.required, Validators.min(1)]);
        this.Implementation_Details.get('noOfWorkshop')?.setValidators([Validators.required, Validators.min(1), Validators.maxLength(3)]);
        this.Implementation_Details.get('targets')?.setValidators([Validators.required, Validators.min(1), Validators.max(this.maxTargetMSME)]);
        //this.Implementation_Details.get('targets')?.setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(5)]);
        //control?.setValidators([Validators.required]); // Add required validator or others as needed

        // Update validation state
        this.Implementation_Details.get('engagementPartnerName')?.updateValueAndValidity();
        this.Implementation_Details.get('districtId')?.updateValueAndValidity();
        this.Implementation_Details.get('noOfWorkshop')?.updateValueAndValidity();
        this.Implementation_Details.get('targets')?.updateValueAndValidity();
      }
      // Update validation state
      //control?.updateValueAndValidity();
    });
  }

  ignoreGeoTimelineValidator(condition: boolean, action: string) {
    const controlsToManage = [
      'proposedDateTraining',
      'proposedDistrict',
      'proposedVenue',
      'proposedNoOfWorkshop',
      'totalTarget'
    ];

    controlsToManage.forEach(controlName => {
      const control = this.Geography_and_Timeline.get(controlName);

      if (condition && action == "prev") {
        // Remove all validators
        control?.clearValidators();
        control?.updateValueAndValidity();
      } else {
        // Enable required validators
        this.Geography_and_Timeline.get('proposedDateTraining')?.setValidators([Validators.required]);
        this.Geography_and_Timeline.get('proposedDistrict')?.setValidators([Validators.required, Validators.min(1)]);
        this.Geography_and_Timeline.get('proposedVenue')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(250), Validators.pattern(this.commonService.notAllowedAampersand)]);
        this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.setValidators([Validators.required, Validators.min(1), Validators.maxLength(3)]);
        this.Geography_and_Timeline.get('totalTarget')?.setValidators([Validators.required, Validators.min(1), Validators.max(this.maxTargetMSME)]);
        //control?.setValidators([Validators.required]); // Add required validator or others as needed

        // Update validation state
        this.Geography_and_Timeline.get('proposedDateTraining')?.updateValueAndValidity();
        this.Geography_and_Timeline.get('proposedDistrict')?.updateValueAndValidity();
        this.Geography_and_Timeline.get('proposedVenue')?.updateValueAndValidity();
        this.Geography_and_Timeline.get('proposedNoOfWorkshop')?.updateValueAndValidity();
        this.Geography_and_Timeline.get('totalTarget')?.updateValueAndValidity();
      }
      // Update validation state
      //control?.updateValueAndValidity();
    });
  }


  ignoreDetailedFinancialsValidator(condition: boolean, action: string) {

    const controlsToManage = [
      'budgetHeadId',
      'cost'
    ];

    controlsToManage.forEach(controlName => {
      const control = this.DetailedFinancials.get(controlName);

      if (condition && action == "prev") {
        // Remove all validators
        control?.clearValidators();
        control?.updateValueAndValidity();
      } else {
        // Enable required validators
        this.DetailedFinancials.get('budgetHeadId')?.setValidators([Validators.required]);
        this.DetailedFinancials.get('cost')?.setValidators([Validators.required, Validators.max(this.maxCost), Validators.min(1)]);
        //control?.setValidators([Validators.required]); // Add required validator or others as needed

        // Update validation state
        this.DetailedFinancials.get('budgetHeadId')?.updateValueAndValidity();
        this.DetailedFinancials.get('cost')?.updateValueAndValidity();
      }
      // Update validation state
      //control?.updateValueAndValidity();
    });
  }


  onUploadProposalFileChange(event: any) {
    const file = event.target.files[0];

    // Reset previous values
    this.uploadError = null;
    this.fileUrl = null;
    this.fileName = '';
    this.certificateFile = null;

    // File is required
    if (!file) {
      this.uploadError = 'Please upload a file.';
      this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.setErrors({ required: true });
      return;
    }

    // File size limit (10MB)
    const maxSizeInMB = 10;
    const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

    // Validate file type (Only PDF)
    if (file.type !== 'application/pdf') {
      this.uploadError = 'Only PDF files are allowed.';
      this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.setErrors({ invalidType: true });
      return;
    }

    // Validate file size (Max 10MB)
    if (fileSizeInMB > maxSizeInMB) {
      this.uploadError = 'File size should not exceed 10 MB.';
      this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.setErrors({ maxSize: true });
      return;
    }

    // If valid, update values
    this.certificateFile = file;
    this.fileName = file.name;

    // Ensure previous object URLs are revoked to prevent memory leaks
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }

    // Create object URL for preview
    this.fileUrl = URL.createObjectURL(file);

    // Store file URL in session storage (not recommended for temporary URLs)
    sessionStorage.setItem('storeFileName', this.fileUrl);

    // Mark field as valid
    this.Intervention_MilestonesForm.get('uploadProposalCertificate')?.setErrors(null);
  }

  
  openFile() {
    if (this.fileUrl) {
      window.open(this.fileUrl, "_blank");
    } else {
      alert("No file uploaded or invalid file!");
      //console.log("openFile() called but fileUrl is null");
    }
  }
  //if(this.Intervention_MilestonesForm?.value.milestone != '' &&
  //  this.Intervention_MilestonesForm?.value.projectStartDate != '' &&
  //  this.Intervention_MilestonesForm?.value.durationInMonth != '' &&
  //this.Intervention_MilestonesForm?.value.estimatedProjectClosure != '') {

  //checkFields() {
  //  const hasValue = Object?.values(this.Intervention_MilestonesForm?.value).some(value => value);
  //  this.isHiddenSubmit = hasValue;
  //  this.isHiddenUpdate = hasValue;
  //}

  //checkImplDetailsFields() {
  //  const hasValue = Object?.values(this.Implementation_Details?.value).some(value => value);
  //  this.isBtnNext = hasValue;
  //  if (this.Implementation_Details.controls['noOfWorkshop']?.value === 0
  //    || this.Implementation_Details.controls['target']?.value === 0) {
  //    this.isBtnNext = true;
  //  }
  //}

  checkImplDetailsFields() {
    const hasValue = Object?.values(this.Implementation_Details?.value).some(value => value);
    //this.isBtnNext = hasValue;
    this.isBtnAdd = false;
    this.isTotalTargetMSMECount = false;
    this.isBtnEdit = false;
    this.isBtnDelete = false;
    if (this.Implementation_Details_submitList.length > 0) {
      this.isTotalTargetMSMECount = true;
    }
    else if (this.TotalTargetMSMECount > this.maxTargetMSME) {
      this.isBtnNext = true;
    } 
    
    this.ChkImplementationDetails();

    if (this.Implementation_Details?.controls['noOfWorkshop']?.value === 0
      || this.Implementation_Details?.controls['target']?.value === 0) {
      this.isBtnNext = true;
    }  
  }



  checkGeoDetailsFields() {   
    const hasValue = Object?.values(this.Geography_and_Timeline?.value).some(value => value);
    //this.isBtnNextGeo = hasValue;
    this.isBtnAddGeo = false;
    this.isTotalTargetMSMECount = false;
    this.isBtnEdit = false;
    this.isBtnDelete = false;
    this.isTotalTargetMSMECount = false;
    if (this.Geography_and_Timeline_submitList.length > 0) {
      this.isTotalTargetMSMECount = true;
    }
    else if (this.TotalTargetMSMECount > this.maxTargetMSME) {
      this.isBtnNextGeo = true;
    }

    //if (this.Geography_and_Timeline_submitList.length > 0) {
    //  this.isTotalTargetMSMECount = true;
    //}
    //else if (this.Geography_and_Timeline_submitList.length == 0) {
    //  this.isTotalTargetMSMECount = false;
    //}

    this.ChkGeographyandTimeline();

    if (this.Geography_and_Timeline?.controls['proposedNoOfWorkshop']?.value === 0
      || this.Geography_and_Timeline?.controls['totalTarget']?.value === 0) {
      this.isBtnNext = true;
    }
    
  }

  checkDetailedFinancialsFields() {
    //const hasValue = Object?.values(this.DetailedFinancials?.value).some(value => value);
    //this.isBtnNext = hasValue;    
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
  
  onProjectStartDateChange(event: any) {
    // event?.value will give you the selected date from the date picker
    const selectedDate = event?.value;   
    const dayOfMonth = selectedDate.getDate(); // This will return 16
    this.proposalSelectedDate.setDate(dayOfMonth)    
  }

  //checkFormErrors() {
  //  Object.keys(this.Geography_and_Timeline.controls).forEach((controlName) => {
  //    const control = this.Geography_and_Timeline.get(controlName);
  //    if (control && control.errors) {
  //      console.log({ controlName }); //has errors:, control.errors);
  //    }
  //  });
  //}

  removeTargetValue() {
    this.Implementation_Details.get('targets')?.setValue("");
    this.Geography_and_Timeline.get('targets')?.setValue("");
    this.ChkImplementationDetails();
    this.ChkGeographyandTimeline();
    this.isBtnNext = true;
    this.isBtnNextGeo = true;
    this.isBtnAdd = true;
    this.isBtnAddGeo = true;
  }
}


